import React, { createContext, useContext, useMemo } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { translations, SUPPORTED_LANGS, DEFAULT_LANG } from "./translations";

const I18nContext = createContext({ lang: DEFAULT_LANG, t: translations[DEFAULT_LANG] });

export const I18nProvider = ({ children }) => {
  const { lang: paramLang } = useParams();
  const lang = SUPPORTED_LANGS.includes(paramLang) ? paramLang : DEFAULT_LANG;
  const value = useMemo(() => ({ lang, t: translations[lang] }), [lang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);

// Returns a function (path) => `/${lang}${path}`
export const useLocalizedPath = () => {
  const { lang } = useI18n();
  return (path = "") => {
    const p = path.startsWith("/") ? path : `/${path}`;
    return `/${lang}${p === "/" ? "" : p}`;
  };
};

// <NLink to="/about">  — auto prefixes with language
export const NLink = ({ to, children, ...rest }) => {
  const make = useLocalizedPath();
  return (
    <Link to={make(to)} {...rest}>
      {children}
    </Link>
  );
};

// Switch the current path between languages
export const useLanguageSwitcher = () => {
  const { lang } = useI18n();
  const location = useLocation();
  return (nextLang) => {
    if (!SUPPORTED_LANGS.includes(nextLang)) return location.pathname;
    const parts = location.pathname.split("/").filter(Boolean);
    if (parts.length === 0) return `/${nextLang}`;
    if (SUPPORTED_LANGS.includes(parts[0])) parts[0] = nextLang;
    else parts.unshift(nextLang);
    return "/" + parts.join("/");
  };
};

export { SUPPORTED_LANGS, DEFAULT_LANG };
